interface ContentTypeCardType {
  icon: string;
  title: string;
  description: string;
}

const ContentTypeCard = ({ icon, title, description }: ContentTypeCardType) => {
  return (
    <div className="rounded-2xl border-2 border-pp-border-primary bg-white p-8 shadow-md transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
      <div className="mb-4 text-center text-5xl">{icon}</div>
      <h4 className="mb-3 text-center text-xl font-bold text-pp-green-primary">
        {title}
      </h4>
      <p className="text-center text-base leading-relaxed text-pp-text-secondary">
        {description}
      </p>
    </div>
  );
};

const WhyPostPrimeSection = () => {
  const contentTypes: ContentTypeCardType[] = [
    {
      icon: '📹',
      title: '動画・音声・テキスト',
      description:
        'コンテンツは、動画、音声、テキストで発信され、クリエイターの得意な形式で情報を受け取れます。',
    },
    {
      icon: '📡',
      title: 'LIVE配信',
      description:
        'LIVE配信での動画視聴も可能です。クリエイターにチャット経由でメッセージ発信や「ありがとう(投げ銭)」など、リアルタイムでのコミュニケーションも可能です。',
    },
    {
      icon: '📺',
      title: '専門チャンネル',
      description:
        '人気クリエイターが米国株、日本株、商品先物、仮想通貨など、各セグメントの市況解説を平日毎日LIVE配信する「専門チャンネル」もあります。',
    },
  ];

  return (
    <section className="w-full bg-white px-6 py-20">
      <div className="mx-auto max-w-6xl">
        <h2 className="mb-4 text-center text-3xl font-bold text-pp-text-primary md:text-4xl">
          なぜPostPrimeなのか
        </h2>
        <p className="mx-auto mb-16 max-w-4xl text-center text-base text-pp-text-secondary md:text-lg">
          PostPrimeは、金融、投資情報の「今」を知りたい人、
          <br />
          発信したい人にとって最良のプラットフォームを目指しています。
        </p>

        {/* Badge System */}
        <div className="mb-16">
          <div className="rounded-3xl bg-pp-green-subtle p-10 shadow-lg transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
            <div className="flex items-start">
              <div className="mr-4 text-5xl">🏅</div>
              <div>
                <h3 className="mb-4 text-2xl font-bold text-pp-green-primary">
                  バッジシステム
                </h3>
                <p className="mb-4 text-lg leading-relaxed text-pp-text-secondary">
                  PostPrimeは良質な情報を提供するため「バッジシステム」を採用しています。発信された情報の関心度、反応率と発信者のフォロワー数を元に情報発信者をレベル分けしています。
                </p>
                <div className="inline-block rounded-lg bg-pp-green-primary px-6 py-3 text-white">
                  <p className="text-base font-semibold">
                    レベル4以上で、クリエイターは発信する情報に課金して収入を得ることができます。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Types */}
        <div className="mb-16">
          <h3 className="mb-8 text-center text-2xl font-bold text-pp-text-primary md:text-3xl">
            多様なコンテンツ形式
          </h3>
          <div className="grid gap-6 md:grid-cols-3">
            {contentTypes.map((content, index) => (
              <ContentTypeCard
                key={index}
                icon={content.icon}
                title={content.title}
                description={content.description}
              />
            ))}
          </div>
        </div>

        {/* Mission Statement */}
        <div className="rounded-2xl bg-pp-green-subtle p-8 text-center shadow-md">
          <p className="text-xl font-semibold leading-relaxed text-pp-text-primary">
            PostPrimeは、金融、投資情報の「今」を知りたい人、
            <br />
            発信したい人にとって最良のプラットフォームを目指しています。
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyPostPrimeSection;
